<template>
  <div id="app">
    <v-app>
      <global-snack-bar></global-snack-bar>
      <router-view/>
      <se-esta-cargando></se-esta-cargando>
      <v-footer
        v-if="updateExists"
        fixed
        padless
        color="transparent">
        <v-row justify="end">
          <v-card class="ma-4 pa-2">
            <v-row justify="center" align="center" class="ma-2">
              <span>Existe una actualización del sistema </span>
              <v-btn
                color="error"
                small
                dark
                class="ml-2"
                @click="refreshApp">
                Actualizar
              </v-btn>
            </v-row>
          </v-card>
        </v-row>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import GlobalSnackBar from '@/components/GlobalSnackBar.vue';
import SeEstaCargando from '@/components/SeEstaCargando.vue';

export default {
  name: 'App',
  components: {
    GlobalSnackBar,
    SeEstaCargando,
  },
  data: () => ({
    test: true,
    refreshing: false,
    worker: null,
    updateExists: false,
  }),
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    // navigator.serviceWorker &&
    // triggered by registration.claim
    // navigator.serviceWorker.addEventListener('controllerchange', () => {
    //   if (this.refreshing) return;
    //   this.refreshing = true;
    //   console.log('controllerchange triggered, -> auto refresh!!');
    //   window.location.reload();
    // });
  },
  methods: {
    showRefreshUI(e) {
      // Display a button inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      if (e.detail) {
        this.worker = e.detail;
        this.updateExists = true;
        // console.log('Showing refresh button.');
        // console.log(this.worker);
      }
      // else {
      //   console.warn('No worker data found!');
      // }
    },
    refreshApp() {
      // console.log('skipWaiting started');
      // console.log(this.worker);
      // Handle a user tap on the update app button.
      this.updateExists = false;
      // Protect against missing registration.waiting.
      if (!this.worker) return;
      // console.warn('No worker data found when trying to refresh!');
      this.worker.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
      // console.log('skipWaiting finished');
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  background-color: #F2F6FF;
  min-height: 100vh;
}

@media print {
  #app {
    background-color: #fff !important;
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
